import React, { useState } from "react";
import { getClassName } from "@sscs/utils";
import { ChevronDownIcon, ChevronUpIcon } from "../../icons";
import { QueryResult } from "../../index";
import Button from "../Button/Button";
import PaginationControl from "../DataTable/Pagination";
import FiltersContainer from "../FiltersContainer/FiltersContainer";
import HeaderRow from "../HeaderRow/HeaderRow";
import ExpandableHeader from "./ExpandableHeader";
import styles from "./page.module.scss";
const Root = ({ id, className, children, }) => (React.createElement("div", { "data-page": true, id: id, className: getClassName(styles.page, className) }, children));
const Header = ({ title, titleAs = "h1", details, actions, description, expand, sticky, id, className, }) => {
    var _a;
    const [isExpanded, setIsExpanded] = useState((_a = expand === null || expand === void 0 ? void 0 : expand.defaultExpanded) !== null && _a !== void 0 ? _a : false);
    const canExpand = expand !== undefined && expand.show !== false;
    const actionsSlot = actions !== undefined || canExpand ? (React.createElement(React.Fragment, null,
        actions,
        canExpand ? (React.createElement(Button, { type: "button", color: "secondary", onClick: () => setIsExpanded((value) => !value), endIcon: isExpanded ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null) }, isExpanded && expand.collapseLabel
            ? expand.collapseLabel
            : expand.expandLabel)) : null)) : undefined;
    return (React.createElement("header", { id: id, className: getClassName(styles.header, description !== undefined ? styles["header-described"] : undefined, sticky ? styles["header-sticky"] : undefined, { [styles["header-expanded"]]: canExpand && isExpanded }, className) },
        React.createElement(HeaderRow, { title: title, titleAs: titleAs, details: details, actions: actionsSlot, classes: {
                root: styles["header-row"],
                title: styles.title,
                details: styles["header-details"],
                actions: styles["header-actions"],
            } }),
        description !== undefined ? (React.createElement("div", { className: styles.description }, description)) : null,
        canExpand && isExpanded ? (React.createElement("div", { className: styles["header-content"] }, expand.children)) : null));
};
const Filters = ({ id, className, children, found, }) => (React.createElement(FiltersContainer, { id: id, className: getClassName(styles.filters, className), found: found }, children));
const Tabs = ({ id, className, children, }) => (React.createElement("div", { id: id, className: getClassName(styles.tabs, className) }, children));
const FloatingActions = ({ id, className, children, }) => (React.createElement("div", { id: id, className: getClassName(styles["floating-actions"], className) },
    React.createElement("div", { className: styles["floating-actions-island"] }, children)));
const Body = ({ status, disableFetching, fetchingClassName, fullBleed, id, className, children, }) => (React.createElement("div", { id: id, className: getClassName(styles.body, fullBleed ? styles["body-bleed"] : undefined, className) }, status ? (React.createElement(QueryResult, { status: status, disableFetching: disableFetching, fetchingClassName: fetchingClassName }, children)) : (children)));
const Pagination = (props) => (React.createElement(PaginationControl, { ...props, className: getClassName(styles.pagination, props.className) }));
export default {
    Root,
    Header,
    ExpandableHeader,
    Filters,
    Tabs,
    FloatingActions,
    Body,
    Pagination,
};
//# sourceMappingURL=Page.js.map